import React, { useEffect, useState } from 'react'
import Button from "reactstrap/es/Button"
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Select, message } from 'antd'
import { bulkUpdateTags } from '../../../services/api/apiNextBarcode'

function BulkUpdateTags(props) {
    const { resetBulkAll, reloadItems, closeMenu, items = [], selectedItems = [] } = { ...props }
    const [isOpen, setIsOpen] = useState(false)
    const [listItems, setListItems] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const _genListItems = () => {
        const listItems = items.filter(item => selectedItems.includes(item._id))
        setListItems(listItems)
    }

    useEffect(() => {
        _genListItems()
    }, [items, selectedItems])

    const _handleToggleModal = () => {
        setIsOpen(!isOpen)
        if (isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    const handleUpdateTags = async () => {
        setLoading(true)
        setError('')
        const payload = {
            "barcode_numbers": listItems.map(item => item.barcodeNumber),
            "tags": ["shipped_vhmc"]
        }
        try {
            const res = await bulkUpdateTags(payload)
            const { success, message: mess } = { ...res }
            if (!success) { throw new Error(mess) }
            message.success('Update tags thành công.')
            setIsOpen(false)
            resetBulkAll()
            closeMenu()
            reloadItems()
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div>
            <Button color="link" onClick={_handleToggleModal} className="mr-1">Đã giao vận hành MC</Button>
            {isOpen && (
                <Modal isOpen={isOpen} className="BulkChangeStatus">
                    <ModalHeader>
                        Đã giao vận hành MC
                    </ModalHeader>
                    <ModalBody>
                        <div className="listItems mb-3">
                            <h6>Danh sách mã đơn:</h6>
                            <Select
                                mode={'tags'}
                                value={listItems.map(item => item.barcodeNumber)}
                                style={{ width: '100%' }}
                                placeholder='Danh sách mã đơn'
                                allowClear
                                disabled
                            />
                        </div>
                        {error && <label className='text-danger'>{error}</label>}
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            <Button
                                disabled={loading}
                                onClick={_handleToggleModal}
                                className="bg-grey ml-2"
                            >
                                Đóng
                            </Button>
                            <Button
                                disabled={loading}
                                onClick={handleUpdateTags}
                                className="bg-primary ml-2"
                            >
                                Cập nhật
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            )}
        </div>
    )
}

export default BulkUpdateTags
